import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.string.search";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import tempTable from '@/components/rw/tempTable/index';
import tempSearch from '@/components/rw/tempSearch/index';
import tempForm from '@/components/rw/tempForm/index';
import tempChart from '@/components/rw/tempChart/index';
import levelCond from './levelCond';
export default {
  components: {
    tempTable: tempTable,
    tempSearch: tempSearch,
    tempForm: tempForm,
    tempChart: tempChart,
    levelCond: levelCond
  },
  props: {
    config: {
      type: Object
    }
  },
  data: function data() {
    var _this = this;

    return {
      reloadTimer: 'reloadTimer',
      tableModel_1000: {
        "border": true,
        "del": false,
        "headerButton": [{
          "id": "",
          "tag": "add",
          "title": "添加",
          "type": "primary"
        }],
        "id": "id_1000",
        "isGroup": false,
        "isTree": false,
        "rowButton": [{
          "icon": "",
          "id": "",
          "tag": "default",
          "title": "晋升条件",
          "type": "success"
        }, {
          "id": "",
          "tag": "edit",
          "title": "编辑",
          "type": "primary"
        }, {
          "id": "",
          "tag": "del",
          "title": "删除",
          "type": "danger"
        }],
        "showPagination": false,
        "showSelection": false,
        "showSummary": false,
        "stripe": false,
        "tableAutocompleteProps": {},
        "tableCascaderProps": {},
        "tableFileProps": {},
        "tableModel": [{
          "add": 0,
          "desc": "",
          "detail": 1,
          "groupId": "",
          "label": "ID",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "80",
          "prop": "id"
        }, {
          "add": 1,
          "desc": "重0开始,按顺序填写，不允许重复",
          "detail": 1,
          "groupId": "",
          "label": "唯一标识",
          "required": 1,
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "80",
          "prop": "tag"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "groupId": "",
          "label": "资格名称",
          "required": 1,
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "150",
          "prop": "name"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "groupId": "",
          "label": "备注",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "300",
          "prop": "remark"
        }],
        "tableName": "",
        "tableRadioProps": {},
        "tableSelectProps": {},
        "tableSwitchProps": {},
        "title": "会员资格",
        "type": "tableTemplate"
      },
      remoteFunc: {}
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.table = this.$refs.ref_1000;
  },
  methods: {
    reqTableData: function reqTableData(params, resolve) {
      var where = {};

      if (this.search) {
        where = this.search.parseWhere();
        params.where = where;
      }

      console.log('this.config.levelData', this.config.levelData);
      resolve({
        total: 0,
        data: this.config.levelData
      });
    },
    reqAdd: function reqAdd(isEdit, params, row, resolve) {
      if (isEdit) {
        var tmpData = this.$tempModel.deepCopy(this.config.levelData);

        for (var i in tmpData) {
          if (tmpData[i].id === row.id) {
            var tmp = this.$tempModel.deepCopy(params);
            tmp.id = row.id;

            for (var key in tmp) {
              tmpData[i][key] = tmp[key];
            }

            this.config.levelData = tmpData;
            console.log("reqAdd", tmpData);
            break;
          }
        }
      } else {
        params.id = this.config.levelId++;
        params.conditions = {
          condData: {}
        };
        this.config.levelData.push(params);
        console.log(' this.config.levelData.push', this.config.levelData);
      }

      resolve();
    },
    reqDel: function reqDel(params, resolve) {
      var ids = params.map(function (item) {
        return item.id;
      });
      var tmp = this.$tempModel.deepCopy(this.config.levelData);
      tmp.map(function (item, idx) {
        if (item.id === ids[0]) {
          tmp.splice(idx, 1);
          return;
        }
      });
      this.config.levelData = tmp;
      resolve();
    },
    onClickLink: function onClickLink(prop, row) {//点击列表link类型回调
    },
    onClickRowButton: function onClickRowButton(btnIndex, row) {
      var _this2 = this;

      //点击列表按钮回调
      if (btnIndex === 0) {
        this.$refs.cond.show(row, function () {
          _this2.table.reloadData();

          _this2.reloadTimer = new Date().getTime();
        });
      }
    },
    onClickHeaderButton: function onClickHeaderButton(btnIndex, row) {//点击列表头部按钮回调
    },
    onSummary: function onSummary(param) {//列表尾部合计回调
    },
    onSwitchChange: function onSwitchChange(val, prop, row) {//列表中switch变化事件
    },
    onClickSearchOperate: function onClickSearchOperate(btnIndex, btnData) {
      //条件菜单按钮点击事件
      if (btnData.tag === this.$tempModel.buttonTag.search) {
        this.table.reloadData();
      } else if (btnData.tag === this.$tempModel.buttonTag.export) {
        this.table.exportExcel();
      } else if (btnData.tag === this.$tempModel.buttonTag.import) {
        var header = btnData.header;
        var results = btnData.results;
      }
    },
    onConditionChange: function onConditionChange(tag, index) {
      this.table.reloadData();
    },
    onRowButtonShow: function onRowButtonShow(btnIndex, row) {
      return true;
    }
  }
};